<template>
  <div id="printPage" class="printPage">
    <div class="print-title">
      <!-- <img src="../../../../assets/img/orderDetail/print-title.png" /> -->
      <img :src="logoImg" />
    </div>
    <div class="print-line"></div>
    <div class="print-body">
      <div class="print-header">
        <div class="print-header-left">
          <div class="print-font">采购订单</div>
        </div>
        <div v-if="isShowExport" class="print-header-right" @click="handleExportPdf">导出PDF</div>
      </div>

      <div class="print-base-info">
        <div>
          <div>买方：</div>
          <div>{{ orderBaseInfo.purchaseCompany }}</div>
        </div>
        <div>
          <div>卖方：</div>
          <div>{{ orderBaseInfo.supplierCompany }}</div>
        </div>
        <div>
          <div>平台订单编号：</div>
          <div>{{ orderBaseInfo.orderNo }}</div>
        </div>
      </div>
      <div class="print-part-1">
        <div class="print-part-1-title">一、商品及价格信息</div>

        <div class="table">
          <TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" :index-show="true">
            <template #quantity="slot">
              {{ slot.scope.row.quantity + '/' + slot.scope.row.goodsUnitName }}
            </template>
            <template #salesTaxRate="slot">
              {{ slot.scope.row.salesTaxRate + '%' }}
            </template>
            <template #price="slot">
              <span style="color: #f0250f">{{ '￥' + slot.scope.row.priceWithMarkup }}</span>
            </template>
            <template #subtotal="slot">
              <span style="color: #f0250f">{{ '￥' + slot.scope.row.subtotal }}</span>
            </template>
          </TableList>
          <div class="print-total">
            <div>
              <div>订单总金额:</div>
              <div>{{ '￥' + calculate.needPay }}</div>
              <div>{{ '元(大写:' + upperPrice + ')' }}</div>
            </div>
            <div>
              <div>运费:</div>
              <div>{{ '￥' + Number(shippingCost).toFixed(2) }}</div>
              <div>{{ '元(大写:' + upperShipping + ')' }}</div>
            </div>
          </div>
          <div class="print-remark">备注：{{ orderBaseInfo.remark }}</div>
        </div>

        <div class="print-delivery-info">
          <div>
            <span>1.交货地址:</span>
            <span style="white-space: pre">{{ deliveryAddress }}</span>
          </div>
          <div>
            <span>2.交货方式:</span>
            <span>{{ orderBaseInfo.shipmentType == 1 ? '供应商配送' : '采购商自提' }}</span>
          </div>
          <div>
            <span>3.约定到货时间:</span>
            <span>{{ orderBaseInfo.arriveTimeTxt }}</span>
          </div>
        </div>
      </div>
      <div class="print-part-2">
        <div class="print-part-2-title">三、结算</div>
        <div style="font-size: 20px">
          <div>1.结算方式:</div>
          <div>{{ orderBaseInfo.isDoCStr }}</div>
        </div>
        <div style="font-size: 20px">
          <div>2.支付方式:</div>
          <div>{{ orderBaseInfo.payType }}</div>
        </div>

        <div class="print-part-2-title">四、溢短装</div>
        <div style="font-size: 20px">
          卖方实际交付产品数量超过或少于合同约定数量,在溢短装范围以内(含)的,不视为违约,按实际交付数量结算;超出
          数量大于溢装范围的,买方不另付款,短少数量大于短装范围的,买方有权要求卖方补齐并承担违约责任。
        </div>

        <div class="print-part-2-title">五、其他</div>
        <div style="font-size: 20px">本采购订单是根据买卖双方的交易意向,在易派客电子商务平台(www.epec.com)系统生成</div>
      </div>

      <div class="print-part-3">
        <ul>
          <li>
            <div>买方（盖章）：</div>
            <div>授权人签字：</div>
            <div>
              签订日期：
              <span>年</span>
              <span>月</span>
              <span>日</span>
            </div>
          </li>
          <li>
            <div>卖方（盖章）：</div>
            <div>授权人签字：</div>
            <div>
              签订日期：
              <span>年</span>
              <span>月</span>
              <span>日</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="print-part-4">
        <div v-if="isShowExport" class="print-part-close" @click="handleClose">关闭</div>
        <div v-if="isShowExport" class="print-part-pdf" @click="handleExportPdf">导出PDF</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../../api/order';
import TableList from './e-table-list';
import utils from '../../utils/utils';

export default {
  name: 'EPrint',
  components: {
    TableList,
  },
  props: {},
  data() {
    return {
      invoiceInfo: '',
      shipmentInfo: '',
      orderBaseInfo: [],
      calculate: {
        type: 'confirm',
        skuCount: 0, // 商品总件数
        needPay: 0, // 订单总价
        taxationSum: 0.0, // 税费
        freightSum: 0.0,
      },
      shippingCost: 0.0,
      loading: false,
      tableLabel: [
        {
          label: '商品名称(编号)',
          param: 'productName',
          align: 'center',
          width: '200',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          width: '80',
        },
        {
          label: '规格型号',
          param: 'displaySkuOptions',
          align: 'center',
        },
        {
          label: '数量/单位',
          param: 'quantity',
          align: 'center',
          slot: 'quantity',
        },
        {
          label: '单价(含税)',
          param: 'priceWithMarkup',
          align: 'center',
          slot: 'price',
        },
        {
          label: '销售税率',
          param: 'salesTaxRate',
          align: 'center',
          slot: 'salesTaxRate',
        },
        {
          label: '金额(含税)',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
        },
      ],
      query: {
        orderId: null,
        purchaseCompanyId: null,
      },
      tableData: [],
      upperPrice: '',
      upperShipping: '',
      logo: require('../../../../assets/img/common/epec.png'),
      isShowExport: true,
      logoImg: require('@/assets/img/orderDetail/print-title.png'),
    };
  },
  computed: {
    // 交货地址
    deliveryAddress() {
      return `${this.shipmentInfo.receiveAddress}    ${this.shipmentInfo.receiveName}    ${this.shipmentInfo.mobiletelephone}`;
    },
  },

  created() {
    this.query.orderId = this.$route.query.orderId;
    this.query.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getOrderDetail();
    this.querySupplierSkuList();
    const { purchaseAreaCompanyId } = this.$store.state.USERINFO;
    if (process.env.NODE_ENV === 'production') {
      if (purchaseAreaCompanyId === 9506269) {
        this.logoImg = require('@/assets/img/orderDetail/cg.png');
      }
    } else if (purchaseAreaCompanyId === 136641) {
      // this.logoImg = 'https://www.baidu.com/img/flexible/logo/pc/result.png';
      // this.logoImg = require('@/assets/img/orderDetail/print-title.png');
      this.logoImg = require('@/assets/img/orderDetail/cg.png');
    }
  },
  methods: {
    getOrderDetail() {
      Api.queryOrderDetail(this.query).then((res) => {
        this.invoiceInfo = res.data.orderInvoiceVO;
        this.shipmentInfo = res.data.shipmentVO;
        this.orderBaseInfo = res.data;
        this.calculate.needPay = Number(res.data.needPay).toFixed(2);
        this.upperPrice = utils.NumberToText(this.calculate.needPay);
        this.calculate.skuCount = res.data.skuCount;
        this.shippingCost =
          res.data.invoiceModeCode != 1 || res.data.orderStatusNum == 18
            ? res.data.shippingCost
              ? Number(res.data.shippingCost)
              : 0.0
            : 0.0;
        this.upperShipping = this.shippingCost == 0.0 ? '零元整' : utils.NumberToText(this.shippingCost);
      });
    },
    querySupplierSkuList() {
      const params = JSON.parse(JSON.stringify(this.query));
      params.pageSize = 999;
      Api.queryOrderSkuList(params)
        .then((res) => {
          this.tableData = [...res.data.records];
          if (this.type == 'orderConfirm') {
            this.tableData.forEach((item) => {
              this.$set(item, 'shippingCost', 0);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClose() {
      window.close();
    },
    handleExportPdf() {
      this.isShowExport = false;
      setTimeout(() => {
        this.getPdf('printPage');
      }, 0);
      setTimeout(() => {
        this.isShowExport = true;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.printPage {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;
  background: url('../../../../assets/img/common/bk-epk.png') repeat;
}
.print-title {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  line-height: 80px;
  img {
    width: 343px;
    height: 54px;
  }
}
.print-line {
  border: 1px solid #000000;
}
.print-body {
  width: 1200px;
  margin: 0 auto;
  .print-header {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .print-header-left {
      border-left: 6px solid #2587ff;
      height: 28px;
      .print-font {
        font-size: 28px;
        color: #333333;
        line-height: 28px;
        margin-left: 10px;
      }
    }
    .print-header-right {
      color: #ffffff;
      width: 75px;
      height: 30px;
      background: #2587ff;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .print-base-info {
    width: 1200px;
    height: 128px;

    background: #fffcec;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    padding-right: 20px;
    div {
      display: flex;
      flex-direction: row;
      div:nth-child(1) {
        width: 150px;
        margin-left: 20px;
        font-size: 20px;
        color: #333333;
        display: flex;
        justify-content: right;
      }
      div:nth-child(2) {
        font-size: 20px;
      }
    }
  }
  .print-part-1 {
    display: flex;
    flex-direction: column;

    .print-part-1-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      height: 56px;
      font-size: 20px;
      color: #333333;
    }
    .print-total {
      height: 88px;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      div:nth-child(1) {
        display: flex;
        margin-left: 10px;
        div:nth-child(1) {
          width: 125px;
          display: flex;
          justify-content: flex-end;
          font-size: 20px;
          line-height: 16px;
          color: #333333;
        }
        div:nth-child(2) {
          font-size: 20px;
          line-height: 16px;

          color: #f0250f;
        }
        div:nth-child(3) {
          font-size: 20px;
          line-height: 16px;

          color: #333333;
        }
      }
      div:nth-child(2) {
        display: flex;
        margin-left: 10px;
        div:nth-child(1) {
          width: 125px;
          display: flex;
          justify-content: flex-end;
          font-size: 20px;
          line-height: 16px;
          color: #333333;
        }
        div:nth-child(2) {
          font-size: 20px;
          line-height: 16px;

          color: #f0250f;
        }
        div:nth-child(3) {
          font-size: 20px;
          line-height: 16px;

          color: #333333;
        }
      }
    }
    .print-remark {
      height: 96px;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      padding-left: 10px;
      padding-top: 12px;
      font-size: 20px;
    }
    .print-delivery-info {
      font-weight: bold;
      margin-top: 20px;
      height: 96px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      span {
        font-size: 20px;

        color: #333333;
      }
    }
  }
  .print-part-2 {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    height: 256px;
    width: 781px;
    justify-content: space-around;
    .print-part-2-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 20px;
      color: #333333;
    }
    div:nth-child(2) {
      display: flex;
      flex-direction: row;
    }
    div:nth-child(3) {
      display: flex;
      flex-direction: row;
    }
  }
  .print-part-3 {
    margin-top: 30px;
    font-size: 20px;
    ul {
      display: flex;
      justify-content: center;
      border: 1px solid #ededed;
      height: 200px;

      li {
        width: 50%;
        border-right: 1px solid #ededed;

        div:nth-child(1) {
          margin-top: 20px;
          margin-left: 20px;
        }
        div:nth-child(2) {
          margin-top: 25px;
          margin-left: 20px;
        }
        div:nth-child(3) {
          margin-top: 60px;
          margin-left: 196px;
          display: flex;
          flex-direction: row;
          span {
            margin-left: 80px;
          }
        }
      }

      li:first-child {
        padding-left: 0px;
      }

      li:last-child {
        border-right: none;
      }
    }
  }
  .print-part-4 {
    display: flex;
    justify-content: center;
    margin-top: 18px;
    .print-part-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 30px;

      background: #ffffff;
      border: 1px solid #c5c5c5;
      color: #333333;
      font-size: 14px;
      margin-right: 30px;
      cursor: pointer;
    }
    .print-part-pdf {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 75px;
      height: 30px;

      background: #2587ff;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
.table {
  ::v-deep .el-table {
    background-color: transparent;
  }
  ::v-deep .el-table tr {
    background-color: transparent;
    font-size: 18px;
    font-weight: bold;
  }

  ::v-deep .el-table .cell {
    font-size: 18px;
  }
}
</style>
